import * as e from "react";
import { forwardRef as l } from "react";
const a = l(
  function(r, t) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        fill: "none",
        ref: t,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...r
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M10.5625 1.6875C10.5625 1.3078 10.8703 1 11.25 1C11.6297 1 11.9375 1.3078 11.9375 1.6875V21.625H10.5625V1.6875Z",
          fill: "#000"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M12.585 1.86816C13.7663 1.6319 14.9837 1.6319 16.165 1.86816L17.3125 2.09668V6.57715L16.3604 6.3877C15.0497 6.12559 13.7003 6.12559 12.3896 6.3877L11.4375 6.57715V2.09668L12.585 1.86816Z",
          fill: "#000",
          stroke: "#000"
        }
      ),
      /* @__PURE__ */ e.createElement("ellipse", { cx: 11.25, cy: 22.3125, fill: "#000", rx: 6.1875, ry: 0.6875 })
    );
  }
);
export {
  a as BetBuilderBadgeCorners
};
